export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "claim_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type de sinistre"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
        "previous_claims": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sinistres précédents"])},
        "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
        "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])}
      },
      "en": {
        "claim_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim type"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
        "previous_claims": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous claims"])},
        "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
        "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])}
      }
    }
  })
}
